export const environment = {
    menu: '_menu',
    TOKEN_NAME: 'access_token',
    USERNAME: 'NombreUsuario',
    USERCODE: "CodigoUsuario",
    SISTEMA: 'CodigoSistema',
    IDSISTEMA: 'IdSistema',
    LISTA_MENU: 'ListaMenu',
    LISTA_SUBMENU: 'ListaSubMenu',
    TIEMPO_SESSION: 10,     //minutos
    IFI: 'NombreIfi',
    IDIFI: 'idIFI',
    IFICODE: 'CodigoIfi',
    ROL: 'CodigoRol',
    APPTITLE: 'PROYECTO BASE',
    //Componentes locales
    apiSUCUrl: "https://api-dev.cofide.com.pe/API-SUC_v2/api",
    //apiSUCUrl: "http://localhost:56493/api",
    apiURL: "https://localhost:7147/api/v1",
    apiSiscenV1Url: "http://srvwebdev/api-siscen/api/v1",
    apiSiscenV2Url: "http://srvwebdev/api-siscen/api/v2",
    apiSubastaUrl: "https://localhost:44301/api/v1",
    appInsights: {
        instrumentationKey: '5e9507eb-e22a-4789-8780-ee116cff2b45'
    },
    loginurl: "https://sso-dev.cofide.com.pe/seguridad/login",
    apiURLArchivos: "https://web-bedev.cofide.com.pe/archivos-impulso/",
}
